import { faAlarmClock as ClockIcon } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import dayjs from 'dayjs';
import duration, { type Duration } from 'dayjs/plugin/duration';

import useStyles from './TimeDisplay.styles';
import type { TimerProps } from './TimeDisplay.types';

const TimeDisplay = (props: TimerProps) => {
  const { closedAt, publishedAt, totalTime, container } = props;
  const { classes } = useStyles({ container });
  let openTime: Duration;
  dayjs.extend(duration);

  if (closedAt === undefined || closedAt === null) {
    /**
     * open tickets
     * difference between the current date/time
     *  */
    openTime = dayjs.duration(dayjs().diff(dayjs(publishedAt)));
  } else {
    /**
     * closed tickets
     * difference between the closed date prop
     *  */
    openTime = dayjs.duration(dayjs(closedAt).diff(dayjs(publishedAt)));
  }

  let days = totalTime ? totalTime.substring(0, 2) : openTime.days();
  let hours = totalTime ? totalTime.substring(3, 5) : openTime.hours();
  let months = totalTime ? null : openTime.months();
  let minutes = totalTime ? totalTime.substring(6, 8) : openTime.minutes();

  // edge case - if value is negative, set to 0
  days = Math.sign(days as number) === -1 ? 0 : days;
  hours = Math.sign(hours as number) === -1 ? 0 : hours;
  months = Math.sign(months as number) === -1 ? 0 : months;
  minutes = Math.sign(minutes as number) === -1 ? 0 : minutes;

  return (
    <div className={classes.openTimer}>
      {!totalTime && (
        <div className={classes.openTimerIcon}>
          <FontAwesomeIcon icon={ClockIcon} size="2xl" />
        </div>
      )}
      {((months && months > 0) || months !== null) && (
        <>
          <div className={classes.openTimerDuration}>
            <div className={classes.openTimerDurationTime}>
              {months.toString().padStart(2, '0')}
            </div>
            <span className={classes.openTimerDurationText}>MONTHS</span>
          </div>
          <div className={classes.openTimerTimeColon}>:</div>
        </>
      )}
      <div className={classes.openTimerDuration}>
        <div className={classes.openTimerDurationTime}>
          {days.toString().padStart(2, '0')}
        </div>
        <span className={classes.openTimerDurationText}>DAYS</span>
      </div>
      <div className={classes.openTimerTimeColon}>:</div>
      <div className={classes.openTimerDuration}>
        <div className={classes.openTimerDurationTime}>
          {hours.toString().padStart(2, '0')}
        </div>
        <span className={classes.openTimerDurationText}>HOURS</span>
      </div>
      <div className={classes.openTimerTimeColon}>:</div>
      <div className={classes.openTimerDuration}>
        <div className={classes.openTimerDurationTime}>
          {minutes.toString().padStart(2, '0')}
        </div>
        <span className={classes.openTimerDurationText}>MINUTES</span>
      </div>
    </div>
  );
};

export default TimeDisplay;
